import { AGENCIES_FAIL, AGENCIES_SHOW, AGENCIES_EDIT, /*AGENCIES_FETCH,*/ AGENCIES_REQUEST, AGENCIES_COMPLETE,
		AGENCIES_MUNICIPALITIES_REQUEST, AGENCIES_MUNICIPALITIES_FETCH} from "../store/config";

const agenciesInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters:{
		q: '',
		state_id: '',
		agenciable_type: '',
		version_id: ''
	},
	municipalities:{
		isFetching: false,
		list: []
	},
	permissions: [],
	edit: {},
	detail: {},
	user: {},
	error: undefined,
	timestamp: undefined
}

const agencies = (state = agenciesInit, action) => {
	switch(action.type) {
		case AGENCIES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case AGENCIES_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case AGENCIES_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case AGENCIES_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case AGENCIES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		case AGENCIES_MUNICIPALITIES_REQUEST: {
			return {
				...state,
				municipalities: {
					...state.municipalities,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		}
		case AGENCIES_MUNICIPALITIES_FETCH: {
			return {
				...state,
				municipalities: {
					...state.municipalities,
					isFetching: action.isFetching,
					list: action.payload
				},
				timestamp: action.timestamp
			}
		}
		default:
			return {
				...state
			}
	}
}

export default agencies;


// WEBPACK FOOTER //
// ./src/reducers/agencies.js